// extracted by mini-css-extract-plugin
module.exports = {"downloadButtonContainer":"DownloadButton_downloadButtonContainer__1zKSX","icon":"DownloadButton_icon__qBvKk","button":"DownloadButton_button__im1Ny"};